import { createContext, useContext } from "react";

export interface EmailDraftsContextValue {
  /** Open a draft in the email form (e.g. right after sending an invoice). */
  openDraft: (id: string) => void;
}

export const EmailDraftsContext = createContext<EmailDraftsContextValue>({ openDraft: () => {} });

export const useEmailDrafts = () => useContext(EmailDraftsContext);
